/* @ngInject */
const generalRun = (
  $transitions
) => {

}

export default generalRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/general/general.run.js